var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-263 355 84 83",
    enableBackground: "new -263 355 84 83",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_283",
    transform: "translate(0.054)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -263.1,
    y: 355,
    width: 84,
    height: 83
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    transform: "translate(0 0)",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fill: "#FDD44C",
    d: "M-262.3,396.5c0-32.2,9-41.2,41.2-41.2s41.2,9,41.2,41.2s-9,41.2-41.2,41.2 S-262.3,428.7-262.3,396.5"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: -235,
    y: 373,
    width: 29.5,
    height: 49.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: -242.3,
    y: 371,
    width: 48.8,
    height: 51.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M-199.6,401.5l-1.1,2.2c-0.6,1.2-1.5,2.1-2.7,2.7l-2.3,1.1l2.2,1.1c1.2,0.6,2.1,1.5,2.7,2.7l1.1,2.2l1.1-2.2 c0.6-1.2,1.5-2.1,2.7-2.7l2.2-1.1l-2.2-1.1l0,0c-1.2-0.6-2.1-1.5-2.7-2.7L-199.6,401.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M-199.6,386.2l1.1-2.2c0.6-1.2,1.5-2.1,2.7-2.7l2.2-1.1l-2.2-1.1l0,0c-1.2-0.6-2.1-1.5-2.7-2.7l-1.1-2.2 l-1.1,2.2c-0.6,1.2-1.5,2.1-2.7,2.7l-2.3,1.1l2.2,1.1c1.2,0.6,2.1,1.5,2.7,2.7L-199.6,386.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M-233.1,389.3l2.1-4.3c0.6-1.2,1.5-2.1,2.7-2.7l4.3-2.1l-4.3-2.1c-1.2-0.6-2.1-1.5-2.7-2.7l-2.1-4.3l-2.1,4.3 c-0.6,1.2-1.5,2.1-2.7,2.7l-4.3,2.1l4.3,2.1c1.2,0.6,2.1,1.5,2.7,2.7L-233.1,389.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M-208.4,388.9c-2.4-2.4-6.2-2.4-8.6,0l-23.3,23.3c-2.3,2.5-2.2,6.3,0.3,8.6c2.3,2.2,6,2.2,8.3,0l23.3-23.3 l0,0C-206,395.2-206,391.3-208.4,388.9L-208.4,388.9z M-233.9,418.7L-233.9,418.7c-1.2,1.2-3.1,1.2-4.3,0c-1.2-1.2-1.2-3.1,0-4.3 l19-19l4.3,4.3L-233.9,418.7z M-210.5,395.4l-2.2,2.2l-4.3-4.3l2.2-2.2c1.2-1.2,3.1-1.2,4.3,0 C-209.3,392.3-209.3,394.2-210.5,395.4L-210.5,395.4L-210.5,395.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAccount);
export default __webpack_public_path__ + "static/media/active-account.30b2045341b00f7d05660341107294ce.svg";
export { ForwardRef as ReactComponent };